// extracted by mini-css-extract-plugin
export default {"alarm":"index_alarm_6Ie8v","commentAd":"index_commentAd_emiT-","commentBottomAd":"index_commentBottomAd_5w8cH","commentsBox":"index_commentsBox_KwNdk"};